import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { XCircle, Building2, ArrowLeft } from 'lucide-react';

export default function SignupCancelled() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-emerald-900 flex items-center justify-center p-6">
      <Card className="max-w-md w-full bg-white/10 backdrop-blur border-white/20">
        <CardContent className="pt-8 pb-8 text-center">
          <div className="w-20 h-20 bg-amber-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-10 h-10 text-amber-400" />
          </div>
          
          <h1 className="text-3xl font-bold text-white mb-2">
            Payment Cancelled
          </h1>
          
          <p className="text-slate-300 mb-6">
            Your payment was cancelled. No charges have been made.
            <br />
            You can try again whenever you're ready.
          </p>

          <div className="space-y-3">
            <Button 
              className="w-full bg-emerald-500 hover:bg-emerald-600"
              onClick={() => navigate('/signup')}
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Try Again
            </Button>
            
            <Button 
              variant="ghost"
              className="w-full text-slate-300"
              onClick={() => navigate('/')}
            >
              Return to Home
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
